"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_spring_1 = require("react-spring");
const react_use_gesture_1 = require("react-use-gesture");
const arrow_1 = __importDefault(require("./components/arrow"));
const bullet_1 = __importDefault(require("./components/bullet"));
const bullets_1 = __importDefault(require("./components/bullets"));
const StyledSliderArrows = styled_components_1.default.div `
	top: 50%;
	position: absolute;
	width: 100%;
	z-index: 1;
	display: flex;
	justify-content: space-between;
`;
const StyledBulletList = styled_components_1.default.ul `
	display: flex;
	justify-content: center;
	list-style-type: none;
	padding: 0;
	margin: 15px 0;
`;
const StyledWrapper = styled_components_1.default.div `
	width: 100%;
	height: 100%;
`;
const StyledSlider = styled_components_1.default.div `
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
`;
const StyledSlide = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	will-change: transform;
	user-select: none;
`;
const clamp = (input, lower, upper) => Math.min(Math.max(input, lower), upper);
const Slider = ({ activeIndex = 0, ArrowComponent = arrow_1.default, arrowStyle = {}, auto = 0, BulletComponent = bullet_1.default, BulletsComponent = bullets_1.default, bulletStyle = {}, children = [], hasArrows = false, hasBullets = false, onSlideChange = () => undefined, setSlideCustom = undefined, slidesAtOnce = 1, slidesToSlide = 1, }) => {
    const sliderRef = react_1.useRef(null);
    const [slide, setSlideOriginal] = react_1.useState(0);
    const setSlide = setSlideCustom
        ? (index) => setSlideOriginal(setSlideCustom(index))
        : setSlideOriginal;
    const [isDragging, setDragging] = react_1.useState(false);
    // Initialize slides with spring
    const [springProps, springPropsRef] = react_spring_1.useSprings(children.length, (index) => ({
        offset: index,
    }));
    // Bindings to set on the element
    const gestureBinds = react_use_gesture_1.useGesture({
        onDrag: ({ down, movement: [xDelta], direction: [xDir], distance, cancel, first, active, }) => {
            if (first) {
                setDragging(true);
            }
            if (sliderRef && sliderRef.current && sliderRef.current.parentElement) {
                const { width, } = sliderRef.current.parentElement.getBoundingClientRect();
                if (down && distance > width / 2) {
                    if (cancel)
                        cancel();
                    if (active) {
                        setSlide(clamp(slide + (xDir > 0 ? -1 : 1), 0, children.length - slidesAtOnce));
                    }
                }
                // see:  https://github.com/react-spring/react-spring/issues/861
                // @ts-ignore
                springPropsRef
                    .update((index) => ({
                    offset: (active && down ? xDelta : 0) / width + (index - slide),
                }))
                    .start();
            }
        },
        onClick: () => {
            if (isDragging) {
                setDragging(false);
                return;
            }
            clickOnSlide(slide);
        },
    }, {
        drag: {
            delay: 200,
        },
    });
    // Triggered on slide change
    react_1.useEffect(() => {
        // see:  https://github.com/react-spring/react-spring/issues/861
        // @ts-ignore
        springPropsRef.update((index) => ({ offset: index - slide })).start();
        onSlideChange(slide);
    }, [slide, springPropsRef, onSlideChange]);
    // Effect for autosliding
    react_1.useEffect(() => {
        let interval;
        if (auto > 0) {
            interval = setInterval(() => {
                const targetIndex = (slide + 1) % children.length;
                setSlide(targetIndex);
            }, auto);
        }
        return () => {
            if (interval)
                clearInterval(interval);
        };
    }, [auto, children.length, slide]);
    // Jump to slide index when prop changes
    react_1.useEffect(() => {
        setSlide(activeIndex % children.length);
    }, [activeIndex, children.length]);
    // Sets pointer events none to every child and preserves styles
    const childs = children.map((child, index) => (react_1.default.createElement(StyledSlide, { key: index }, child) // eslint-disable-line react/no-array-index-key
    ));
    // Calls onClick on the current slide
    const clickOnSlide = (slideIndex) => {
        childs[slideIndex].props.children.props.onClick &&
            childs[slideIndex].props.children.props.onClick();
    };
    const goToFirstSlide = () => {
        setSlide(0);
    };
    const goToLastSlide = () => {
        setSlide(children.length - slidesAtOnce);
    };
    const nextSlide = () => {
        const reachedLastSlide = slide === children.length - slidesAtOnce;
        const nextSlideExists = slide + (slidesAtOnce - 1) + slidesToSlide < children.length - 1;
        if (reachedLastSlide) {
            goToFirstSlide();
        }
        else if (!nextSlideExists) {
            goToLastSlide();
        }
        else {
            setSlide(slide + slidesToSlide);
        }
    };
    const previousSlide = () => {
        if (slide === 0) {
            goToLastSlide();
            return;
        }
        else if (slide - slidesToSlide <= 0) {
            goToFirstSlide();
            return;
        }
        else {
            setSlide(slide - slidesToSlide);
        }
    };
    const bullets = () => {
        const arr = [];
        for (let index = 0; index <= children.length - slidesAtOnce; index++) {
            arr.push(react_1.default.createElement(BulletComponent, { key: index, isActive: index === slide, onClick: () => setSlide(index), style: bulletStyle }));
        }
        return arr;
    };
    return (react_1.default.createElement(StyledWrapper, { ref: sliderRef },
        react_1.default.createElement(StyledSlider, null,
            hasArrows && (react_1.default.createElement(StyledSliderArrows, null,
                react_1.default.createElement(ArrowComponent, { style: arrowStyle, direction: "left", onClick: previousSlide }),
                react_1.default.createElement(ArrowComponent, { style: arrowStyle, direction: "right", onClick: nextSlide }))),
            hasBullets && (react_1.default.createElement(BulletsComponent, null,
                react_1.default.createElement(StyledBulletList, null, bullets()))),
            springProps.map(({ offset }, index) => (react_1.default.createElement(react_spring_1.animated.div, Object.assign({}, gestureBinds(), { key: index, className: "slider__slide", style: {
                    transform: offset.to((offsetX) => `translate3d(${offsetX * 100}%, 0, 0)`),
                    position: "absolute",
                    width: `${100 / slidesAtOnce}%`,
                    height: "100%",
                    willChange: "transform",
                    touchAction: "none",
                } }), childs[index]))))));
};
exports.default = Slider;
